// hooks/useLanguage.js
import { useState, useEffect } from 'react';
import { languages, defaultLanguage } from '../languages';

export const useLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Try to get language from localStorage or use default
    const saved = localStorage.getItem('haunted-house-language');
    return saved && languages[saved] ? saved : defaultLanguage;
  });

  const changeLanguage = (langCode) => {
    if (languages[langCode]) {
      setCurrentLanguage(langCode);
      localStorage.setItem('haunted-house-language', langCode);
    }
  };

  const t = languages[currentLanguage];

  return {
    currentLanguage,
    changeLanguage,
    t
  };
};